// import { createContext, useContext, useEffect, useState } from "react";
// import { io, Socket } from "socket.io-client";

// interface ISocketContext {
//   socket: Socket | null;
// }

// const SocketContext = createContext<ISocketContext>({ socket: null });

// export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
//   const [socket, setSocket] = useState<Socket | null>(null);

//   useEffect(() => {
//     const newSocket = io("https://97b5-103-186-216-28.ngrok-free.app");
//     setSocket(newSocket);

//     return () => {
//       newSocket.disconnect();
//     };
//   }, []);

//   return (
//     <SocketContext.Provider value={{ socket }}>
//       {children}
//     </SocketContext.Provider>
//   );
// };

// export const useSocket = () => useContext(SocketContext);

import React, { createContext, useContext } from "react";
import { io, Socket } from "socket.io-client";

interface SocketContextType {
  socket: Socket | null;
  registerUser: (userId: number) => void;
  registerSuccess: (userId: number, userId2: number) => void;
  connectUsers: (user1Id: number, user2Id: number) => void;
  sendPrivateMessage: (
    senderId: number,
    recipientId: number,
    message: string,
    attachments?: {
      type: string;
      link: string;
    }[]
  ) => void;
  sendGroupMessage: (
    senderId: number,
    groupId: number,
    message: string,
    attachments?: {
      type: string;
      link: string;
    }[]
  ) => void;
}

const SocketContext = createContext<SocketContextType | null>(null);

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context)
    throw new Error("useSocket must be used within a SocketProvider");
  return context;
};

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // TODO:
  // const socket = io("https://22f1-103-186-216-28.ngrok-free.app", {
  //   transports: ["websocket", "polling"],
  //   autoConnect: true,
  // });
  const socket = io(process.env.REACT_APP_API, {
    transports: ["websocket", "polling"],
    autoConnect: true,
  });

  // console.log(socket);

  //   useEffect(() => {
  //     return () => {
  //       socket.disconnect();
  //     };
  //   }, []);

  const registerUser = (userId: number) => {
    socket.emit("register", { userId });
  };

  const registerSuccess = (userId: number, user2Id: number) => {
    socket.on("registerSuccess", () => {
      console.log("register success", userId, user2Id);

      connectUsers(userId, user2Id);
    });
  };

  const connectUsers = (user1Id: number, user2Id: number) => {
    socket.emit("connect_users", { user1Id, user2Id });
  };

  const sendPrivateMessage = (
    senderId: number,
    recipientId: number,
    message: string,
    attachments?: {
      type: string;
      link: string;
    }[]
  ) => {
    // console.log("inside of private message", {
    //   senderId,
    //   recipientId,
    //   message,
    // });

    socket.emit("private_message", {
      senderId,
      recipientId,
      message,
      attachments,
    });
  };

  const sendGroupMessage = (
    senderId: number,
    groupId: number,
    message: string,
    attachments?: {
      type: string;
      link: string;
    }[]
  ) => {
    socket.emit("send_group_message", {
      sender_id: senderId,
      group_id: groupId,
      message,
      attachments,
    });
  };

  return (
    <SocketContext.Provider
      value={{
        socket,
        registerUser,
        registerSuccess,
        connectUsers,
        sendPrivateMessage,
        sendGroupMessage,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
